<template>
  <div>
    <el-dialog
      width="640px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      v-if="dialogFormVisible"
      :visible.sync="dialogFormVisible"
      title="说辞表上传"
    >
      <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="100px" size="small">
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="SPU名称" prop="spuName">
<!--              <el-input v-model="requestParam.spuName" readonly/>-->
              {{requestParam.spuName}}
            </el-form-item>
            <el-form-item label="更新说明" prop="updateInstructions">
              <el-input v-model="requestParam.updateInstructions" />
            </el-form-item>
            <el-form-item label="模板类型" prop="excuseType">
              <el-select v-model="requestParam.excuseType">
                <el-option label="板式" value="1"></el-option>
                <el-option label="沙发软床" value="2"></el-option>
                <el-option label="床垫" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="附件">
              <el-upload
                class="upload-demo"
                ref="upload"
                accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                :limit="1"
                action=""
                :http-request="httpRequest"
                :on-remove="handleRemove"
                :headers="headers"
                :file-list="fileList"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
              >
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-button style="margin-left: 10px;"
                            v-loading.fullscreen.lock="fjLoading"
                            element-loading-text="数据导入中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                            size="small" type="success" @click="checkFormValid">上传
                </el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getToken} from '@/utils/auth'
import moment from 'moment'
export default {
  data() {
    return {
      dialogFormVisible: false,
      titleName: '',
      requestParam: {
        excuseType: '1',
        updateInstructions: '新增'
      },
      headers: {
        'Authorization': getToken()
      },
      fileList: [],
      rules: {},
      fjLoading: false
    }
  },
  methods: {
    importProduct(row) {
      this.fileList = [];
      this.dialogFormVisible = true;
      let fileName = '说辞表'
      this.titleName = '说辞表上传';
      this.$set(this.requestParam, 'spuName', row.spuName);
      this.$set(this.requestParam, 'spuId', row.spuId);
    },
    cancel() {
      this.dialogFormVisible = false;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      console.log(file, fileList);
    },
    httpRequest(file) {

    },
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
    },
    // 验证
    beforeUpload(file) {
      // .xls,.xlsx,.xls.ttt,.xlsx.ttt
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error('请上传后缀名为.xls,.xlsx的附件！');
        return false;
      }
      this.fileList = [];
      this.fileList.push(file);
    },
    checkFormValid(file) {
      this.$refs['requestParam'].validate(async valid=>{
        if(valid) {

          await this.submitUpload(file);
        }else{
          this.$message.error('参数校验失败！')
        }
      })
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传Excel附件');
        return;
      }
      this.fjLoading = true;

      let taskDTO=null;
      let fields = [
        {
          columnName: "更新说明",
          columnValue: this.requestParam.updateInstructions,
          fieldName: "updateInstructions",
          fieldValue: this.requestParam.updateInstructions,
          relation: "updateInstructions"
        }
      ];
      taskDTO = {
        ...this.requestParam,
        // paramMap: fields,
        fileType: 3 //文件类型（1bom表，2信息表，3说辞表）
      };
      return this.$q.newProduct.informationUpload({
        data: {
          file: this.fileList[0],
          paramJson: JSON.stringify(taskDTO)
        }
      }, true)
      .then((res) => {
        if (res.success) {
          this.nextUpload(res.data.fileId, this.requestParam.excuseType);
        } else {
          this.$message.error(res.message);
          this.fjLoading = false;
        }
      })
      .catch(err=>{
        this.fjLoading = false;
      })
    },
    // 说辞表导入
    nextUpload(fileId, excuseType) {
      let taskDTO=null;

      let fields = [
        {
          columnName: "更新说明",
          columnValue: this.requestParam.updateInstructions,
          fieldName: "updateInstructions",
          fieldValue: this.requestParam.updateInstructions,
          relation: "updateInstructions"
        }
      ];
      taskDTO = {
        reportName: excuseType == '1' ? 'excusePlateImport' :
        excuseType == '2' ? 'excuseSofaBedImport' :
        'excuseMattressImport',
        appCode: "ec-pc-new",
        fileId: fileId,
        excuseType: excuseType,
        paramMap: fields//预销计划
      };

      this.$q.common.uploadFile({
        data: {
          file: this.fileList[0],
          taskDTO: JSON.stringify(taskDTO)
        }
      })
      .then((res) => {
        if (res.success) {
          this.$message.success('数据导入中，请稍后');
        } else {
          this.$message.error(res.message);
        }
        this.$router.push('/wordSheet?appCode=ec-pc-new&fileName=说辞表.xlsx');
      })
      .finally(()=>{
        this.fjLoading = false
      });
    }
  },
  mounted() {}
}
</script>

<style>

</style>
